module.exports = __webpack_public_path__ + "static/media/ruler-horizontal.7c93b337.svg";